import { MutableRefObject, useEffect, useState } from "react";
import db from "src/db";

export const WarehouseNameCell = ({
  ids,
  isPrepack,
  cache,
}: {
  ids: string[];
  isPrepack: boolean;
  cache?: MutableRefObject<Map<string, string[]>>;
}) => {
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    let isMounted = true;
    if (!ids || ids.length === 0) return;

    const cacheKey = `${isPrepack}-${ids.sort().join(",")}`;
    const cached = cache.current.get(cacheKey);

    if (cached) {
      setNames(cached);
      return;
    }

    const fetchWarehouseNames = async () => {
      const promises = ids.map(async (id) => {
        const snap = await db
          .collection("marketplaceWarehouseMap")
          .where("marketplaceWarehouseId", "==", id)
          .get();
        return snap.docs[0]?.data() ?? null;
      });

      const results = await Promise.all(promises);
      const warehousePromises = results
        .filter((result) => result !== null)
        .map(async (result) => {
          const warehouseRef = isPrepack
            ? result?.prepackWarehouse
            : result?.pickupWarehouse;
          const warehouseName = warehouseRef
            ? (await warehouseRef.get()).data()?.name
            : "";
          return warehouseName;
        });

      const warehouseNames = await Promise.all(warehousePromises);

      if (isMounted) {
        setNames(warehouseNames);
        cache.current.set(cacheKey, warehouseNames);
      }
    };

    fetchWarehouseNames();

    return () => {
      isMounted = false;
    };
  }, [ids, isPrepack]);

  return (
    <div>
      <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
        {names.join(", ")}
      </p>
    </div>
  );
};
